import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Header nav moves into the bottom bar below this width. Page compact layout
 * stays on MUI `md` (900px); this only changes the app header.
 */
export const HEADER_COMPACT_BREAKPOINT_PX = 990;

/**
 * True below MUI `md` (900px): phones and portrait tablets. Desktop layout
 * (docked assistant, conversations rail) stays unchanged at `md` and up.
 */
export function useCompactLayout(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
}

/** True below {@link HEADER_COMPACT_BREAKPOINT_PX}: the header is the mobile bar. */
export function useHeaderCompact(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(HEADER_COMPACT_BREAKPOINT_PX));
}
